import { render } from "./AddGeneralLedger.vue?vue&type=template&id=0d3fb060"
import script from "./AddGeneralLedger.vue?vue&type=script&lang=js"
export * from "./AddGeneralLedger.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Accounting/AddGeneralLedger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d3fb060"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d3fb060', __exports__)) {
    api.reload('0d3fb060', __exports__)
  }
  
  module.hot.accept("./AddGeneralLedger.vue?vue&type=template&id=0d3fb060", () => {
    api.rerender('0d3fb060', render)
  })

}


export default __exports__